import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../config";
import notifications from "../../assets/json/notifications";
import Indiaflag from "../../assets/img/icons/flag1.png";

import message from "../../assets/json/message";

import User from "../../assets/img/icons/user3.png";

import { FaRegBell } from "react-icons/fa";
import { useLocation } from "react-router-dom/dist";
import { useTranslation } from "react-i18next";
import { formatDateTimeInTimezone } from "../../utils/formatDateInTimezone";
import { capitalizeFirstLetter, formatName } from "../../utils/basicFunctions";
import { onLogoutSuccess } from "../pages/Authentication/TrackingHandler";
import { clearAuthToken } from "../../utils/tokenStorage";
import { clearRefreshTokenExpiry } from "../../utils/sessionExpiry";
import { getEmployeeTimeZoneDate } from "../../utils/getEmployeeTimeZoneDate";
import api from "../../api/axios";
import { getFile } from "../../utils/getFile";
import CompanySelectorModal from "../../components/CompanySelectorModal";
import CheckoutConfirmModal from "../../components/modelpopup/CheckoutConfirmModal";
import {
  isCheckedIn,
  isWfhAutoCheckoutActive,
  markCheckedOut,
  stopWfhTracking,
} from "../../utils/wfhTracking";
import { CONFIRM_MESSAGE } from "../../hooks/useCheckoutOnTabClose";
import { getEmployer, switchCompany } from "../../services/companyService";
import i18n from "../../i18n";
import SwitchDemoRole from "../../components/SwitchDemoRole";
import { encrypt } from "../../utils/crypto";

const Header = () => {
  const companyName = localStorage.getItem("companyName") || "HR Globes";
  const employeeOfficialEmail = localStorage.getItem("employeeOfficialEmail");
  const multipleEmployer = localStorage.getItem("multipleEmployer") === "1";
  const demoEmployee = localStorage.getItem("demoEmployee") === "1";
  const data = notifications.notifications;
  const navigate = useNavigate();
  const datas = message.message;
  const [notification, setNotifications] = useState(false);
  const [flag, setflag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState(false);
  const [search, setSearch] = useState(false);
  const [employeeProfileData, setEmployeeProfileData] = useState({});
  const [toggleTrue, setToggleTrue] = useState(false);
  const searchRef = useRef(null);
  const employee_id = localStorage.getItem("employeeID");
  const [profileImage, setProfileImage] = useState(null);
  const [chooseCompany, setChooseCompany] = useState({
    show: false,
    companies: [],
  });
  const [switchRoleModal, setSwitchRoleModal] = useState(false);
  const [encryptedEmployeeId, setEncryptedEmployeeId] = useState("");

  const closeChooseCompany = () => {
    setChooseCompany({ ...chooseCompany, show: false });
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const onMenuClik = () => {
    setToggleTrue(!toggleTrue);
    // if (document.body.classList.contains("slide-nav")) {
    // document.body.classList.remove("slide-nav");
    // } else {
    //   console.log("cliched on menuclick")
    document.body.classList.add("slide-nav");
    // }
  };

  const themes = localStorage.getItem("theme");
  const [openNotification, setOpenNotification] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setNotifications(false);
    setProfile(false);
    setflag(false);
  };

  const handleNotification = () => {
    setNotifications(!notification);
    setflag(false);
    setIsOpen(false);
    setProfile(false);
    setOpenNotification(!openNotification);
  };
  const handleProfile = () => {
    setProfile(!profile);
    setNotifications(false);
    setflag(false);
    setIsOpen(false);
  };

  const location = useLocation();
  let pathname = location.pathname;
  const Credencial = localStorage.getItem("credencial");
  const Value = JSON.parse(Credencial);
  const UserName = Value?.email?.split("@")[0];
  const ProfileName = UserName?.charAt(0).toUpperCase() + UserName?.slice(1);

  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  const searchToggling = () => {
    setSearch(!search);
  };

  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setSearch(false);
    }
  };

  useEffect(() => {
    if (search) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [search]);

  // ------------------logout handling---------------
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  // Performs the session logout. When `doCheckout` is true the user is first
  // checked out of attendance and location tracking is stopped.
  const performLogout = async (doCheckout) => {
    const multipleEmployer = localStorage.getItem("multipleEmployer") === "1";
    const company_url = localStorage.getItem("company_url");
    const punchDate = getEmployeeTimeZoneDate();

    try {
      if (doCheckout) {
        // Auto-checkout attendance, then stop tracking + clear the check-in flag.
        await api.post(`auth/logout`, {
          punchDate: punchDate,
          employeeId: employee_id,
          checkOut: true,
        });
        stopWfhTracking();
        markCheckedOut();
      }

      const res = await api.post(`auth/logout`, {
        punchDate: punchDate,
        employeeId: employee_id,
      });
      if (res.data.success === true) {
        clearAuthToken();
        clearRefreshTokenExpiry();
        onLogoutSuccess();
        if (company_url && !multipleEmployer) {
          navigate(`/${company_url}`);
        } else {
          navigate("/");
        }
        window.location.reload();
      }
    } catch (err) {
      console.error("Error during logout:", err);
    }
  };

  const handleLogout = (e) => {
    e.preventDefault();
    // Only WFH sessions should trigger the extra checkout confirmation.
    if (isCheckedIn() && isWfhAutoCheckoutActive()) {
      setShowLogoutConfirm(true);
      return;
    }
    performLogout(false);
  };

  const handleConfirmLogout = async () => {
    setLoggingOut(true);
    await performLogout(true);
    setLoggingOut(false);
    setShowLogoutConfirm(false);
  };

  const handleCancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  //-----------------------  employee Profiling----------------------------

  const [userId, setUserID] = useState("");
  const [notificationsData, setNotificationsData] = useState([]);

  useEffect(() => {
    try {
      const fetchData = async () => {
        let employeeDetails = localStorage.getItem("user");
        if (employeeDetails) {
          let employee = JSON.parse(employeeDetails);
          localStorage.setItem("employeeID", employee?.id);
          // Update userId so notifications re-fetch for the current employee
          setUserID(employee?.id);
          try {
            const res = await api.get(
              `employees/employee_details/${employee?.id}`
            );
            if (res.data.success == true) {
              setEmployeeProfileData(res?.data?.results);
              const encryptedEmployeeId = encrypt(
                res?.data?.results?.employee_id ?? ""
              );
              setEncryptedEmployeeId(encryptedEmployeeId);
            }
          } catch (error) {
            console.error("error", error);
          }
        }
      };

      fetchData();
    } catch (err) {
      console.error(err);
    }
  }, []);

  const fetchNotifications = async (currentUserId) => {
    try {
      const response = await api.get(`hr/${currentUserId}/notifications`);
      setNotificationsData(response?.data?.result || []);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    if (!userId) return;

    // Clear old notifications immediately so stale data isn't shown
    setNotificationsData([]);
    fetchNotifications(userId);

    const ws = new WebSocket("ws://localhost:8080");

    ws.onmessage = (event) => {
      const {
        receiverId,
        type,
        message,
        first_name,
        last_name,
        photo,
        id,
        created_at,
      } = JSON.parse(event.data);
      if (receiverId == userId) {
        setNotificationsData((prevNotifications) =>
          [
            ...prevNotifications,
            { type, message, first_name, last_name, photo, id, created_at },
          ].reverse()
        );
      }
    };

    return () => ws.close();
  }, [userId]);

  const clearAllNotification = () => {
    setNotifications(false);
    const data = notificationsData.map((item) => item.id);
    api
      .post(`hr/notification-update`, data)
      .then((res) => console.log("updated notification", res))
      .catch((err) => console.error(err));
    fetchNotifications(userId);
  };

  const readNotificationHandler = (id) => {
    api
      .put(`notification-is-read/${id}`)
      .then((res) => {
        fetchNotifications(userId);
      })
      .catch((err) => console.error("readNotificationHandler", err));
  };

  useEffect(() => {
    const fetchImage = async () => {
      let image = null;
      if (employeeProfileData?.photo) {
        const imageUrl = await getFile(
          `${config.IMAGE_URL}${employeeProfileData.photo}`
        );
        if (imageUrl) {
          image = imageUrl;
        }
      }
      setProfileImage(image);
    };

    fetchImage();
  }, [employeeProfileData]);

  const fetchMultipleEmployer = async () => {
    try {
      const response = await getEmployer(employeeOfficialEmail);
      const multipleCompany = response?.multipleCompany;
      if (multipleCompany) {
        setChooseCompany({ show: true, companies: response?.companies });
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <div className="header" style={{ right: "0px" }}>
      {/* Logo */}
      <div className="header-left">
        <Link
          to="../"
          className="logo"
          style={{ color: "white", fontSize: "22px" }}
        >
          {t("HR Globes")}
        </Link>
        <h2> </h2>
      </div>
      {/* /Logo */}
      <Link
        id="toggle_btn"
        to="#"
        style={{
          display: pathname.includes("tasks")
            ? "none"
            : pathname.includes("compose")
            ? "none"
            : "",
        }}
        onClick={handlesidebar}
      >
        <span className="bar-icon">
          <span />
          <span />
          <span />
        </span>
      </Link>
      {/* Header Title */}
      <div className="page-title-box">
        <h3>{companyName.toUpperCase()}</h3>
      </div>
      {/* /Header Title */}
      <Link
        id="mobile_btn"
        className="mobile_btn"
        to="#"
        onClick={() => onMenuClik()}
        // style={{border:"2px solid red"}}
      >
        <i className="fa fa-bars" />
      </Link>
      {/* Header Menu */}
      <ul className="nav user-menu">
        {/* Search */}
        {/* <li className="nav-item">
          <div className="top-nav-search">
            <Link to="#" className="responsive-search">
              <i className="fa fa-search" />
            </Link>
            {search ? (
              <form ref={searchRef}>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search here"
                />
                <button className="btn" type="submit">
                  <i
                    className="fa fa-search"
                    style={{ marginBottom: "15px" }}
                  />
                </button>
              </form>
            ) : (
              <i
                className="fa fa-search"
                style={{
                  marginLeft: "10px",
                  color: "white",
                  marginTop: "14px",
                }}
                onClick={searchToggling}
              />
            )}
          </div>
        </li> */}
        {/* /Search */}
        {/* Flag */}

        {/* <li className="nav-item dropdown has-arrow flag-nav">
          <Link
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            to="#"
            role="button"
          >
            <i className="fa-solid fa-language me-2" />
            {t(i18n.language)}
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              to="#"
              className="dropdown-item"
              onClick={(e) => {
                e.preventDefault();
                changeLanguage("en");
              }}
            >
              English
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={(e) => {
                e.preventDefault();
                changeLanguage("hi");
              }}
            >
              Hindi
            </Link>
          </div>
        </li> */}
        {/* /Flag */}

        {/* Notifications */}
        <li className="nav-item dropdown">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={handleNotification}
          >
            <i>
              <FaRegBell />
            </i>
            {notificationsData && notificationsData?.length > 0 && (
              <span className="badge badge-pill">
                {notificationsData?.length}
              </span>
            )}
          </Link>
          <div
            className={`dropdown-menu dropdown-menu-end notifications ${
              notification ? "show" : ""
            }`}
          >
            <div className="topnav-dropdown-header">
              <span className="notification-title">Notifications</span>
              <Link
                to="#"
                onClick={() => clearAllNotification()}
                className="clear-noti"
              >
                {" "}
                Clear All{" "}
              </Link>
            </div>
            <div className="noti-content">
              <ul className="notification-list">
                {notificationsData.map((val, index) => {
                  return (
                    <li className="notification-message" key={index}>
                      <div className="media d-flex m-1">
                        <span className="avatar flex-shrink-0">
                          <img
                            alt=""
                            src={`${config.IMAGE_URL}${val?.photo}`}
                          />
                        </span>
                        <div className="media-body">
                          <p className="noti-details">
                            <Link
                              className="p-0"
                              to={{
                                pathname: `taskbox/${encrypt(employee_id)}`,
                              }}
                              state={{
                                task_id: val.related_request_id,
                                notification_id: val.id,
                                type: val.type,
                                target_employee_id: val.employee_id,
                              }}
                              onClick={() => {
                                localStorage.setItem("minheight", "true");
                                readNotificationHandler(val.id);
                              }}
                            >
                              <span className="noti-title">
                                {val?.first_name ? val?.first_name : ""}{" "}
                                {val?.last_name ? val?.last_name : ""}
                              </span>{" "}
                              <span>{val?.message}</span>
                            </Link>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              {formatDateTimeInTimezone(val?.created_at)}
                            </span>
                          </p>
                        </div>
                        {/* <div
                          onClick={() => readNotificationHandler(val.id)}
                          style={{ marginLeft: "auto" }}
                        >
                          <span
                            style={{
                              padding: "1px",
                              paddingRight: "2px",
                              cursor: "pointer",
                              color: "#f5db1b",
                              textDecoration: "underline",
                            }}  
                          >
                            mark as read
                          </span>
                        </div> */}
                      </div>
                      {/* </Link> */}
                    </li>
                  );
                })}
              </ul>
            </div>
            {/* <div className="topnav-dropdown-footer">
              <Link
                onClick={() => localStorage.setItem("minheight", "true")}
                to={`taskbox/${encrypt(employee_id)}`}
              >
                View all Notifications
              </Link>
            </div> */}
          </div>
        </li>
        <li className="nav-item dropdown has-arrow main-drop">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={handleProfile}
          >
            {" "}
            <span className="user-img me-1">
              <img
                src={profileImage ?? User}
                alt="img"
                style={{ width: "40px", height: "40px" }}
              />
              <span className="status online" />
            </span>
            <span>
              {localStorage.getItem("demo_user_name")
                ? formatName(localStorage.getItem("demo_user_name"))
                : employeeProfileData
                ? `${capitalizeFirstLetter(employeeProfileData?.first_name)}`
                : ""}
            </span>
          </Link>
          <div
            className={`dropdown-menu dropdown-menu-end ${
              profile ? "show" : ""
            }`}
          >
            <Link
              className="dropdown-item text-black"
              to={`employees/profile/${encryptedEmployeeId}`}
            >
              <i class="fa-solid fa-user" /> My Profile
            </Link>
            {multipleEmployer && (
              <Link
                className="dropdown-item text-black"
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  fetchMultipleEmployer();
                }}
              >
                {" "}
                <i className="fa-solid fa-sitemap" /> Switch Company
              </Link>
            )}
            {demoEmployee && (
              <Link
                className="dropdown-item text-black"
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  setSwitchRoleModal(true);
                }}
              >
                {" "}
                <i className="fa-solid fa-arrows-rotate me-1" />
                Switch Demo Role
              </Link>
            )}
            <Link
              className="dropdown-item text-black"
              to="#"
              onClick={handleLogout}
            >
              <i class="fa-solid fa-right-from-bracket" /> Logout
            </Link>
          </div>
        </li>
      </ul>
      {/* /Header Menu */}
      {/* Mobile Menu */}
      <div className="dropdown mobile-user-menu">
        <Link
          to="#"
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa fa-ellipsis-v" />
        </Link>
        <div className="dropdown-menu dropdown-menu-end dropdown-menu-right">
          <Link
            className="dropdown-item"
            to={`employees/profile/${encryptedEmployeeId}`}
          >
            <i className="fa-solid fa-user"></i> My Profile
          </Link>
          {multipleEmployer && (
            <Link
              className="dropdown-item"
              to="#"
              onClick={(e) => {
                e.preventDefault();
                fetchMultipleEmployer();
              }}
            >
              {" "}
              <i className="fa-solid fa-sitemap" /> Switch Company
            </Link>
          )}
          {demoEmployee && (
            <Link
              className="dropdown-item"
              to="#"
              onClick={(e) => {
                e.preventDefault();
                setSwitchRoleModal(true);
              }}
            >
              {" "}
              <i className="fa-solid fa-arrows-rotate me-1" />
              Switch Demo Role
            </Link>
          )}
          <Link
            className="dropdown-item"
            to="#"
            onClick={handleLogout}
          >
            <i className="fa-solid fa-right-from-bracket" /> Logout
          </Link>
        </div>
      </div>
      {/* /Mobile Menu */}
      {chooseCompany.show && multipleEmployer && (
        <CompanySelectorModal
          show={chooseCompany.show}
          onHide={closeChooseCompany}
          onContinue={(selectedCompany) =>
            switchCompany(
              selectedCompany?.employee_id,
              selectedCompany?.employeeWorkLocation
            )
          }
          companies={chooseCompany?.companies}
        />
      )}
      {demoEmployee && switchRoleModal && (
        <SwitchDemoRole
          show={switchRoleModal}
          onHide={() => setSwitchRoleModal(false)}
        />
      )}
      <CheckoutConfirmModal
        show={showLogoutConfirm}
        message={CONFIRM_MESSAGE}
        loading={loggingOut}
        onConfirm={handleConfirmLogout}
        onCancel={handleCancelLogout}
      />
    </div>
  );
};

export default Header;
